import { useEffect } from 'react';
import { useLocation } from '../../../../helpers/routing';
import { getUrlSlug, isChatbotUrl, isT404PUrl } from '../../../../helpers/url';
import { LocationState, SurveyContainerLocationState } from '../../../survey-container/types';

export const usePreloadTheme = () => {
  const location = useLocation() as LocationState;
  const { mghUrl }: SurveyContainerLocationState = location.state || {};
  const urlSlug = getUrlSlug(mghUrl, location).toLowerCase();

  useEffect(() => {
    if (isChatbotUrl(urlSlug)) {
      import('./ChatbotTheme');
    } else if (isT404PUrl(urlSlug)) {
      import('./VirtualCareTheme');
    } else {
      import('./ClassicTheme');
    }
  }, [urlSlug]);

  return null;
};
